export default function enumValuesExist(myEnum: any, value: any) {
    return Object.values(myEnum).every(() =>
        Object.values(myEnum).includes(value!)
      );
}